import { MantineThemeOverride } from '@mantine/core';

export const theme: MantineThemeOverride = {
  primaryShade: 6,
  primaryColor: 'accent',
  colors: {
    accent: [
      '#F5F5FF',
      '#ECEBFF',
      '#DDDCFE',
      '#ADA1FC',
      '#8D83FB',
      '#7771FA',
      '#5750FA',
      '#4245FA',
      '#1737F6',
      '#122FD6'
    ],
    systemDark: [
      '#F8F9FA',
      '#F1F3F5',
      '#E9ECEF',
      '#DEE2E6',
      '#CED4DA',
      '#ADB5BD',
      '#868E96',
      '#495057',
      '#343A40',
      '#212529'
    ],
    success: [
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971',
      '#02C971'
    ],
    warning: [
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C',
      '#FF922C'
    ],
    failure: [
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980',
      '#E64980'
    ]
  },

  cursorType: 'pointer',
  defaultRadius: 'sm',

  // Breakpoints needs to be defined and confirmed
  breakpoints: {
    xs: '22rem',
    sm: '48rem',
    md: '64rem',
    lg: '74rem',
    xl: '90rem'
  }
};
